import React, { useEffect } from "react";
import "./invoice-client.scss";
import { useDispatch, useSelector } from "react-redux";
import {
  invoiceRequest,
  payToInvoice,
  deleteBankingToInvoice,
  invoiceToPay,
} from "../../../../store/actions/invoice";
import Spinner from "../../../../components/spinner";
import { Link } from "react-router-dom";
import Button from "@material-ui/core/Button";
import { getInvoiceClientSelector } from "../../../../selectors/invoice-selectors";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell/TableCell";
import TableBody from "@material-ui/core/TableBody";
import Table from "@material-ui/core/Table";

const CheckBanking = ({ invoice, openPay }) => {
  if (invoice.state.id === 1) {
    return <Button onClick={openPay}>Оплатить</Button>;
  } else return null;
};

const InvoiceClient = (props) => {
  const { id } = props.match.params;
  const dispatch = useDispatch();
  const invoice = useSelector((state) => getInvoiceClientSelector(state));
  const loading = useSelector((state) => state.discount.invoicesLoading);

  const state_training_children = [
    { id: 1, name: "Был" },
    { id: 2, name: "Не был" },
  ];

  const colorStyle = (id) => {
    if (id === 1) {
      return { backgroundColor: "#4A9DD9" };
    } else return { backgroundColor: "#F14343" };
  };

  const colorStatePaid = (id) => {
    if (id === 1) {
      return { color: "#F14343" };
    } else return { color: "#81CC5E" };
  };

  const openPay = () => {
    if (invoice?.price === 0) {
      dispatch(invoiceToPay(id));
      return;
    }
    dispatch(payToInvoice(id));
  };

  useEffect(() => {
    document.title = "Абонемент";
    dispatch(invoiceRequest(id));
  }, [dispatch, id]);

  if (loading) {
    return <Spinner open={loading} isWhite />;
  }

  return (
    <div className="invoiceClientWrapper">
      <div className="invoiceClientHeader">
        <h2>
          Абонемент <span>{invoice.name}</span> для{" "}
          <Link to={`/client/child/${invoice.children_id}`}>
            {invoice.children.last_name} {invoice.children.first_name}
          </Link>{" "}
        </h2>
        <span className="invoiceClientHeaderPath">
          Главная &rarr; {invoice.children.first_name}
          &rarr; Абонемент
        </span>
        <label>
          Филиал:<span>{invoice.group?.filial?.name}</span>
        </label>
        <label>
          Группа:<span>{invoice.group.name}</span>
        </label>
      </div>
      <div className="invoiceClientContent">
        <div className="invoiceClientContentInfo">
          <div className="contentInfoContainer">
            <div className="contentInfoPay">
              <span>Статус:</span>
              {invoice.error && invoice.banking ? (
                <>
                  <label style={colorStatePaid(invoice.state.id)}>
                    Ошибка оплаты
                  </label>
                  <Button
                    onClick={() => {
                      dispatch(deleteBankingToInvoice(invoice.id));
                    }}
                  >
                    Повторить
                  </Button>
                </>
              ) : (
                <>
                  <label style={colorStatePaid(invoice.state.id)}>
                    {invoice.state.description}
                  </label>
                  <CheckBanking invoice={invoice} openPay={openPay} />{" "}
                </>
              )}
            </div>
            <div className="contentInfoItem">
              <label className="contentInfoItemHeader">Занятия ост.</label>
              <label>{invoice.balance}</label>
              <label className="contentInfoItemFooter">
                <span>из</span>
                {invoice.count}
              </label>
            </div>
          </div>
          <div className="contentInfoContainer">
            <div className="contentInfoItem">
              <label className="contentInfoItemHeader">Стоимость</label>
              <label>{invoice.price}</label>
              <span>1 занятие</span>
              <label className="contentInfoItemFooter">
                {invoice.base_price}р.
              </label>
            </div>
            <div className="contentInfoItem">
              <label className="contentInfoItemHeader">Пропуски</label>
              <label>{invoice.missed}</label>
              <label className="contentInfoItemFooter">
                <span>из</span>
                {invoice.count}
              </label>
            </div>
          </div>
        </div>
        <div className="invoiceClientContentTimeTable">
          <h3>Расписание занятий:</h3>
          {invoice.training.map((item) => (
            <div className="itemTimeTableContainer" key={item.id}>
              <span
                className="itemTimeTableStatus"
                style={colorStyle(item.state_training_children.id)}
              />
              <span>{item.start}</span>
            </div>
          ))}
        </div>
        <div className="invoiceClientContentTimeTableDesktop">
          <h3>Расписание занятий:</h3>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell style={{ fontWeight: "700" }}>Дата</TableCell>
                <TableCell align="center" style={{ fontWeight: "700" }}>
                  Статус
                </TableCell>
                <TableCell align="center" style={{ fontWeight: "700" }}>
                  Комментарий
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {invoice.training?.map((row) => (
                <TableRow key={row.id}>
                  <TableCell component="th" scope="row">
                    {row.startDesktop}
                  </TableCell>
                  <TableCell align="center">
                    {
                      state_training_children.find(
                        (el) => el.id === row.state_training_children.id
                      )?.name
                    }
                  </TableCell>
                  <TableCell align="center">{row.comment}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </div>
    </div>
  );
};

export default InvoiceClient;
